var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M523.929-32.326q-85.407 0-160.166-32.143-74.758-32.144-130.954-88.34-56.196-56.196-88.339-130.954-32.144-74.759-32.144-160.166 0-152.134 96.837-266.059Q306-823.913 456.239-850.391q-16.043 99.478 11.337 195.217 27.381 95.739 99.62 166.978 70.761 72 166.739 99.261 95.978 27.261 196.217 12.892-25.239 149-139.782 246.358-114.544 97.359-266.441 97.359Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.1f631b01efcfc6e670845f02e9bb33e3.svg";
export { ForwardRef as ReactComponent };